<template>
  <div style="background-color: #f6f5f5">
    <template v-if="isReadInfo"> </template>
    <template v-else>
      <v-alert v-if="isReadonly" text type="warning">
        <div class="black--text"
          >Mohon maaf, Anda tidak dapat mengubah pertanyaan karena terdapat responden yang telah mengisi kuesioner.
          Terima kasih atas pemahaman Anda.</div
        >
      </v-alert>
      <v-alert v-else text type="info">
        <div class="black--text">
          Anda ingin melihat kuesioner Anda sebelum mempublikasikannya? Silakan buka tab pratinjau untuk melihat
          hasilnya.
        </div>
      </v-alert>
    </template>
    <v-form @submit.prevent data-vv-scope="form" lazy-validation>
      <v-card v-for="(form, f) in forms" :key="f" class="mb-5">
        <v-card-text class="pa-5 black--text">
          <span class="text-h6 font-weight-regular"> Pertanyaan ke - {{ f + 1 }} </span>
          <div class="mt-2">
            <v-row>
              <v-col cols="12" md="7" sm="12">
                <span class="grey--text">Pertanyaan</span>
                <v-text-field
                  dense
                  single-line
                  outlined
                  label="Judul Kuesioner"
                  hint="Isikan judul kuesioner"
                  v-model="form.label"
                  :readonly="isReadonly"
                  :data-vv-name="`survey_${f + 1}`"
                  :data-vv-as="`Pertanyaan ke ${f + 1}`"
                  v-validate="'required'"
                  :error-messages="errors.collect(`form.${'survey_' + (f + 1)}`)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="5" sm="12">
                <span class="grey--text">Model Jawaban</span>
                <v-select
                  v-model="form.k_tipe_soal"
                  :items="models"
                  dense
                  outlined
                  placeholder="Pilih Model"
                  item-value="value"
                  item-text="label"
                  :readonly="isReadonly"
                  :data-vv-name="`opsi_${f + 1}`"
                  :data-vv-as="`Pilihan ke ${f + 1}`"
                  v-validate="'required'"
                  :error-messages="errors.collect(`form.${'opsi_' + (f + 1)}`)"
                  @change="changeOpsi(f)"
                >
                  <template v-slot:item="{ item }">
                    <v-icon left>{{ item.icon }}</v-icon>
                    {{ item.label }}
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-icon left>{{ item.icon }}</v-icon>
                    {{ item.label }}
                  </template>
                </v-select>
              </v-col>
              <v-col v-if="form['k_tipe_soal']" class="py-2 my-n2" cols="12" md="12" sm="12">
                <template v-if="[1, 2, 3].includes(form.k_tipe_soal)">
                  <div v-for="(option, o) in form.opsi" :key="o" class="d-flex justify-space-between">
                    <v-sheet class="">
                      <v-text-field
                        v-model="option['label']"
                        :readonly="isReadonly"
                        style="width: 400px"
                        :disabled="option.is_catatan === 1"
                        :placeholder="`opsi ${o + 1}`"
                      >
                        <template v-slot:prepend>
                          <span v-if="form.k_tipe_soal == 3" class="mt-1">{{ o + 1 }}</span>
                          <v-icon v-else>
                            {{ icons[form.k_tipe_soal] }}
                          </v-icon>
                        </template>
                      </v-text-field>
                    </v-sheet>
                    <v-sheet class="mt-4">
                      <v-btn v-if="!isReadonly" small icon color="red" @click="delOption(o, f)">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-sheet>
                  </div>
                  <div v-if="!isReadonly">
                    <a @click="addOption(f)">
                      <v-icon left>mdi-plus</v-icon>
                      Tambah Opsi
                    </a>
                    <span v-if="!getDeepObj(form, 'is_catatan') && ![4, 5].includes(form.k_tipe_soal)">
                      atau isian "<a @click="addLainnya(f)">Lainnya...</a> "(responden dapat mengisikan jawaban bebas)
                    </span>
                  </div>
                </template>
                <template v-else>
                  <component
                    :is="form.k_tipe_soal == 4 ? 'VTextField' : 'VTextarea'"
                    :label="form.k_tipe_soal == 4 ? 'Jawaban Singkat' : 'Jawaban Paragraf'"
                    :placeholder="
                      form.k_tipe_soal == 4
                        ? 'Teks jawaban singkat dari responden (maksimal 60 karakter)'
                        : 'Teks jawaban panjang dari responden (maksimal 180 karakter)'
                    "
                    persistent-placeholder
                    outlined
                    dense
                    disabled
                    row="3"
                  >
                  </component>
                </template>
              </v-col>
              <v-col cols="12" class="py-2" md="12" sm="12">
                <v-divider />
                <div class="d-flex flex-row-reverse">
                  <v-sheet class="pt-5">
                    <m-menu v-if="!isReadonly" style="float: right" :items="more_menu" :object="f" />
                  </v-sheet>
                  <v-sheet class="px-1">
                    <v-switch
                      v-model="form['is_required']"
                      label="Wajib diisi"
                      color="primary"
                      :true-value="1"
                      :false-value="0"
                      :disabled="isReadonly"
                      hide-details
                    ></v-switch>
                  </v-sheet>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-form>
    <div v-if="!isReadonly" class="d-flex flex-row-reverse mt-5">
      <v-btn color="primary" @click="addQuestion"> <v-icon left>mdi-plus</v-icon> Pertanyaan </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  $_veeValidate: {
    validator: 'new',
  },
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    isReadInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      forms: [],
      more_menu: [
        {
          title: 'Duplikasi',
          icon: 'mdi-content-copy',
          icnColor: 'blue',
          click: (i, o) => this.onDuplicate(o),
        },
        {
          title: 'Hapus',
          icon: 'mdi-delete',
          icnColor: 'red',
          click: (i, o) => this.onDelete(o),
          check: () => this.forms.length !== 1,
        },
      ],
      icons: { 1: 'mdi-radiobox-blank', 2: 'mdi-checkbox-blank-outline' },
      models: [
        {
          type: 'radio',
          icon: 'mdi-radiobox-blank',
          label: 'Pilihan Ganda',
          value: 1,
        },
        {
          type: 'checkbox',
          icon: 'mdi-checkbox-marked',
          label: 'Kotak Centang',
          value: 2,
        },
        {
          type: 'select',
          icon: 'mdi-arrow-down-drop-circle-outline',
          label: 'Tarik Turun',
          value: 3,
        },
        {
          type: 'short',
          icon: 'mdi-text-short',
          label: 'Jawaban Singkat',
          value: 4,
        },
        {
          type: 'long',
          icon: 'mdi-text',
          label: 'Jawaban Paragraf',
          value: 5,
        },
      ],
    }
  },
  methods: {
    addOption(f) {
      // const length = this.forms[f]['opsi'].length || 0
      this.forms[f]['opsi'].push({
        label: ``,
      })
    },
    delOption(index, f) {
      if (this.getDeepObj(this.forms, `${f}.opsi.${index}.type`) === 'opsi') {
        this.$delete(this.forms[f], 'is_catatan')
      }
      this.forms[f]['opsi'].splice(index, 1)
    },
    addLainnya(f) {
      this.$set(this.forms[f], 'is_catatan', true)
      this.forms[f]['opsi'].push({ label: 'Lainnya...', is_catatan: 1 })
    },
    addQuestion() {
      this.forms.push({ opsi: [], is_required: 1 })
    },
    onDuplicate(index) {
      const item = Object.assign({}, this.forms[index] || {})
      this.forms.splice(index + 1, 0, JSON.parse(JSON.stringify(item)))
    },
    onDelete(index) {
      this.forms.splice(index, 1)
    },
    changeOpsi(index) {
      if (
        this.forms[index] &&
        this.forms[index]['k_tipe_pengisian'] &&
        Number(this.forms[index]['k_tipe_pengisian']) > 3
      ) {
        this.$delete(this.forms[index], 'opsi')
      } else {
        if (this.forms[index] && this.forms[index]['opsi'].length === 0) this.forms[index]['opsi'] = [{ label: '' }]
      }
    },
    reset() {
      this.$validator.reset()
      this.forms = []
      if (this.forms.length === 0) {
        this.addQuestion()
      }
    },
    initForm(items) {
      this.forms = []
      if (items.length) {
        this.forms = items
      }
    },
    async getValue(isNotValidate = false) {
      if (isNotValidate) {
        return []
      }
      const validator = await this.$validator.validateAll('form')
      if (!validator) {
        return false
      } else {
        let items = JSON.parse(JSON.stringify(this.forms || [])) || []
        if (items.length > 0) {
          items.map((item, i) => {
            if ([4, 5].includes(Number(item.k_tipe_soal))) {
              delete item.opsi
            }
            if (item.opsi && typeof item.opsi === 'object' && item.opsi.length > 0) {
              item.opsi.map((op, i) => {
                op.urutan = i + 1
                return op
              })
            }
            item.urutan = i + 1
            return item
          })
        }
        return items || []
      }
    },
  },
  watch: {
    forms: {
      handler(item) {
        this.$emit('surveys', item)
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
